import * as actionTypes from "../action-types";
import {
  getActiveCampaigns,
  getDeactiveCampaigns,
  addCampaign,
  delCampaignById,
  getCampaignById,
  updateCampaignById,
  getCampaigns,
} from "../../api/campaign";
import { uploadImage } from "../../api/image.js";
import { message } from "antd";

const actionCreators = {
  getActiveCampaigns(data) {
    return (dispatch) =>
      new Promise(async (resolve, reject) => {
        try {
          dispatch({ type: actionTypes.SHOW_LOADING, payload: true });
          let res = await getActiveCampaigns(data);
          resolve(res);
        } catch (error) {
        } finally {
          dispatch({ type: actionTypes.HIDE_LOADING, payload: false });
        }
      });
  },

  getDeactiveCampaigns(data) {
    return (dispatch) =>
      new Promise(async (resolve, reject) => {
        try {
          dispatch({ type: actionTypes.SHOW_LOADING, payload: true });
          console.log("comecome");
          console.log("data", data);
          let res = await getDeactiveCampaigns(data);

          console.log("res", res);
          resolve(res);
        } catch (error) {
        } finally {
          dispatch({ type: actionTypes.HIDE_LOADING, payload: false });
        }
      });
  },

  getCampaigns(data, isActive) {
    console.log("isActive 111", isActive);
    return (dispatch) =>
      new Promise(async (resolve, reject) => {
        try {
          dispatch({ type: actionTypes.SHOW_LOADING, payload: true });
          let res = await getCampaigns(data, isActive);
          resolve(res);
        } catch (error) {
        } finally {
          dispatch({ type: actionTypes.HIDE_LOADING, payload: false });
        }
      });
  },

  addCampaign(data) {
    return (dispatch) =>
      new Promise(async (resolve, reject) => {
        try {
          dispatch({ type: actionTypes.SHOW_LOADING, payload: true });
          let res = await addCampaign(data);
          resolve(res);
        } catch (error) {
        } finally {
          dispatch({ type: actionTypes.HIDE_LOADING, payload: false });
        }
      });
  },

  updateCampaignById(data) {
    return (dispatch) =>
      new Promise(async (resolve, reject) => {
        try {
          dispatch({ type: actionTypes.SHOW_LOADING, payload: true });
          let res = await updateCampaignById(data);
          resolve(res);
        } catch (error) {
        } finally {
          dispatch({ type: actionTypes.HIDE_LOADING, payload: false });
        }
      });
  },

  uploadImage(data) {
    return (dispatch) =>
      new Promise(async (resolve, reject) => {
        try {
          dispatch({ type: actionTypes.SHOW_LOADING, payload: true });
          let res = await uploadImage(data);
          resolve(res);
        } catch (error) {
        } finally {
          dispatch({ type: actionTypes.HIDE_LOADING, payload: false });
        }
      });
  },

  getCampaignById(data) {
    return (dispatch) =>
      new Promise(async (resolve, reject) => {
        try {
          dispatch({ type: actionTypes.SHOW_LOADING, payload: true });
          let res = await getCampaignById(data);
          resolve(res);
        } catch (error) {
        } finally {
          dispatch({ type: actionTypes.HIDE_LOADING, payload: false });
        }
      });
  },

  delCampaignById(data) {
    return (dispatch) =>
      new Promise(async (resolve, reject) => {
        try {
          dispatch({ type: actionTypes.SHOW_LOADING, payload: true });
          let res = await delCampaignById(data);
          resolve(res);
        } catch (error) {
        } finally {
          dispatch({ type: actionTypes.HIDE_LOADING, payload: false });
        }
      });
  },

  updateCampaignById(data) {
    return (dispatch) =>
      new Promise(async (resolve, reject) => {
        try {
          dispatch({ type: actionTypes.SHOW_LOADING, payload: true });
          let res = await updateCampaignById(data);
          resolve(res);
        } catch (error) {
        } finally {
          dispatch({ type: actionTypes.HIDE_LOADING, payload: false });
        }
      });
  },

  // getQualifyingPurchases(data) {
  //   return (dispatch) =>
  //     new Promise(async (resolve, reject) => {
  //       try {
  //         dispatch({ type: actionTypes.SHOW_LOADING, payload: true });
  //         let res = await getQualifyingPurchases(data);
  //         resolve(res);
  //       } catch (error) {
  //       } finally {
  //         dispatch({ type: actionTypes.HIDE_LOADING, payload: false });
  //       }
  //     });
  // },
  // getQualifyingPurchasesRedeemed(data) {
  //   return (dispatch) =>
  //     new Promise(async (resolve, reject) => {
  //       try {
  //         dispatch({ type: actionTypes.SHOW_LOADING, payload: true });
  //         let res = await getQualifyingPurchasesRedeemed(data);
  //         resolve(res);
  //       } catch (error) {
  //       } finally {
  //         dispatch({ type: actionTypes.HIDE_LOADING, payload: false });
  //       }
  //     });
  // },
  // addQualifyingPurchases(data) {
  //   return (dispatch) =>
  //     new Promise(async (resolve, reject) => {
  //       try {
  //         dispatch({ type: actionTypes.SHOW_LOADING, payload: true });
  //         let res = await addQualifyingPurchases(data);
  //         resolve(res);
  //       } catch (error) {
  //       } finally {
  //         dispatch({ type: actionTypes.HIDE_LOADING, payload: false });
  //       }
  //     });
  // },
  // uploadImage(data) {
  //   return (dispatch) =>
  //     new Promise(async (resolve, reject) => {
  //       try {
  //         dispatch({ type: actionTypes.SHOW_LOADING, payload: true });
  //         let res = await uploadImage(data);
  //         resolve(res);
  //       } catch (error) {
  //       } finally {
  //         dispatch({ type: actionTypes.HIDE_LOADING, payload: false });
  //       }
  //     });
  // },
  // getOfferById(data) {
  //   return (dispatch) =>
  //     new Promise(async (resolve, reject) => {
  //       try {
  //         dispatch({ type: actionTypes.SHOW_LOADING, payload: true });
  //         let res = await getOfferById(data);
  //         resolve(res);
  //       } catch (error) {
  //       } finally {
  //         dispatch({ type: actionTypes.HIDE_LOADING, payload: false });
  //       }
  //     });
  // },
  // updataOfferById(data) {
  //   return (dispatch) =>
  //     new Promise(async (resolve, reject) => {
  //       try {
  //         dispatch({ type: actionTypes.SHOW_LOADING, payload: true });
  //         let res = await updataOfferById(data);
  //         resolve(res);
  //       } catch (error) {
  //       } finally {
  //         dispatch({ type: actionTypes.HIDE_LOADING, payload: false });
  //       }
  //     });
  // },
  // delOfferById(data) {
  //   return (dispatch) =>
  //     new Promise(async (resolve, reject) => {
  //       try {
  //         dispatch({ type: actionTypes.SHOW_LOADING, payload: true });
  //         let res = await delOfferById(data);
  //         resolve(res);
  //       } catch (error) {
  //       } finally {
  //         dispatch({ type: actionTypes.HIDE_LOADING, payload: false });
  //       }
  //     });
  // },
  // getQualifyingpurchasesCount(data) {
  //   return (dispatch) =>
  //     new Promise(async (resolve, reject) => {
  //       try {
  //         dispatch({ type: actionTypes.SHOW_LOADING, payload: true });
  //         let res = await getQualifyingpurchasesCount(data);
  //         resolve(res);
  //       } catch (error) {
  //         reject(error);
  //       } finally {
  //         dispatch({ type: actionTypes.HIDE_LOADING, payload: false });
  //       }
  //     });
  // },
  // getQualifyingpurchasesRedeemedCount(data) {
  //   return (dispatch) =>
  //     new Promise(async (resolve, reject) => {
  //       try {
  //         dispatch({ type: actionTypes.SHOW_LOADING, payload: true });
  //         let res = await getQualifyingpurchasesRedeemedCount(data);
  //         resolve(res);
  //       } catch (error) {
  //       } finally {
  //         dispatch({ type: actionTypes.HIDE_LOADING, payload: false });
  //       }
  //     });
  // },
  // getExpiredQualifyingPurchases(data) {
  //   return (dispatch) =>
  //     new Promise(async (resolve, reject) => {
  //       try {
  //         dispatch({ type: actionTypes.SHOW_LOADING, payload: true });
  //         let res = await getExpiredQualifyingPurchases(data);
  //         resolve(res);
  //       } catch (error) {
  //       } finally {
  //         dispatch({ type: actionTypes.HIDE_LOADING, payload: false });
  //       }
  //     });
  // },
  // getExpiredQualifyingpurchasesCount(data) {
  //   return (dispatch) =>
  //     new Promise(async (resolve, reject) => {
  //       try {
  //         dispatch({ type: actionTypes.SHOW_LOADING, payload: true });
  //         let res = await getExpiredQualifyingpurchasesCount(data);
  //         resolve(res);
  //       } catch (error) {
  //       } finally {
  //         dispatch({ type: actionTypes.HIDE_LOADING, payload: false });
  //       }
  //     });
  // },
};
export default actionCreators;
